import React, { lazy } from 'react';
import { FadeIn } from './FadeIn';
import { Star, Quote, Crown } from 'lucide-react';
export function WholesaleTestimonials() {
  const testimonials = [{
    quote: 'Me ayudó muchísimo a entender cómo funciona Wholesale realmente. Ahora ya sé cómo buscar proveedores y analizar productos.',
    name: 'Carlos M.',
    image: 'https://randomuser.me/api/portraits/men/1.jpg',
    role: 'Emprendedor'
  }, {
    quote: 'Pensé que Wholesale era complicado, pero aquí explican todo súper claro y paso a paso.',
    name: 'Daniela R.',
    image: 'https://randomuser.me/api/portraits/women/2.jpg',
    role: 'Estudiante'
  }, {
    quote: 'Lo mejor fue aprender cómo contactar distribuidores y entender cómo funcionan las cuentas mayoristas.',
    name: 'Miguel A.',
    image: 'https://randomuser.me/api/portraits/men/3.jpg',
    role: 'Vendedor en Amazon'
  }, {
    quote: 'Ya estoy utilizando Keepa y RevSeller gracias al sistema. Súper recomendado.',
    name: 'Andrea C.',
    image: 'https://randomuser.me/api/portraits/women/4.jpg',
    role: 'Emprendedora online'
  }, {
    quote: 'Había visto videos antes pero nunca entendía bien. Aquí todo se siente mucho más organizado.',
    name: 'Luis Fernando P.',
    image: 'https://randomuser.me/api/portraits/men/5.jpg',
    role: 'Principiante'
  }, {
    quote: 'Me encantó porque enseñan herramientas reales que sí se usan en Amazon Wholesale.',
    name: 'Valentina G.',
    image: 'https://randomuser.me/api/portraits/women/6.jpg',
    role: 'Vendedora'
  }, {
    quote: 'Aprendí cómo validar productos antes de invertir dinero. Eso me dio mucha más seguridad.',
    name: 'Kevin T.',
    image: 'https://randomuser.me/api/portraits/men/7.jpg',
    role: 'Emprendedor'
  }, {
    quote: 'El módulo de análisis de productos tiene muchísimo valor.',
    name: 'Nicole M.',
    image: 'https://randomuser.me/api/portraits/women/9.jpg',
    role: 'Estudiante'
  }, {
    quote: 'Me gustó que explican Seller Central paso a paso y de forma sencilla.',
    name: 'Sebastián A.',
    image: 'https://randomuser.me/api/portraits/men/10.jpg',
    role: 'Nuevo vendedor'
  }, {
    quote: 'Ahora entiendo mucho mejor cómo vender marcas conocidas dentro de Amazon.',
    name: 'Laura P.',
    image: 'https://randomuser.me/api/portraits/women/12.jpg',
    role: 'Emprendedora'
  }, {
    quote: 'Los bonos premium ayudan muchísimo para investigar productos rentables.',
    name: 'Ricardo V.',
    image: 'https://randomuser.me/api/portraits/men/13.jpg',
    role: 'Vendedor'
  }, {
    quote: 'El sistema se siente muy premium y profesional.',
    name: 'Camila S.',
    image: 'https://randomuser.me/api/portraits/women/14.jpg',
    role: 'Estudiante'
  }, {
    quote: 'Me ayudó bastante a entender cómo funciona el negocio Wholesale desde cero.',
    name: 'Javier C.',
    image: 'https://randomuser.me/api/portraits/men/15.jpg',
    role: 'Principiante'
  }, {
    quote: 'Las herramientas y softwares explicados en el curso valen muchísimo.',
    name: 'Mariana T.',
    image: 'https://randomuser.me/api/portraits/women/16.jpg',
    role: 'Emprendedora'
  }, {
    quote: 'Muy organizado y fácil de seguir incluso para principiantes.',
    name: 'Andrés F.',
    image: 'https://randomuser.me/api/portraits/men/19.jpg',
    role: 'Nuevo vendedor'
  }, {
    quote: 'Ahora tengo mucha más claridad sobre cómo comenzar en Amazon Wholesale.',
    name: 'Alejandra N.',
    image: 'https://randomuser.me/api/portraits/women/20.jpg',
    role: 'Estudiante'
  }, {
    quote: 'Me gustó que enseñan estrategias reales y no solo teoría.',
    name: 'Fernando L.',
    image: 'https://randomuser.me/api/portraits/men/21.jpg',
    role: 'Emprendedor'
  }, {
    quote: 'Todo se siente actualizado y moderno comparado con otros cursos.',
    name: 'Paola R.',
    image: 'https://randomuser.me/api/portraits/women/22.jpg',
    role: 'Vendedora online'
  }];
  return <section className="bg-brand-white py-20 md:py-28 px-5 sm:px-6 relative overflow-hidden" data-id="element-1002">
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50" data-id="element-1003">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-brand-gold/5 rounded-full blur-3xl" data-id="element-1004"></div>
        <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-brand-green/5 rounded-full blur-3xl" data-id="element-1005"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-1006">
        <FadeIn data-id="element-1007">
          <div className="text-center mb-14 md:mb-20 max-w-3xl mx-auto" data-id="element-1008">
            <div className="inline-flex items-center justify-center gap-2 bg-brand-green text-white border border-brand-gold/40 rounded-full px-5 py-2.5 mb-6 shadow-lg" data-id="element-1009">
              <Crown className="w-4 h-4 text-brand-gold" data-id="element-1010" />
              <span className="text-xs font-bold tracking-widest text-brand-gold uppercase" data-id="element-1011">
                SISTEMA WHOLESALE
              </span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-brand-green mb-5 leading-[1.1] tracking-tight" data-id="element-1012">
              RESULTADOS DE PERSONAS REALES
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-id="element-1013">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.05 * (index % 6)} data-id="element-1014">
              <article className="group bg-white border border-brand-text/8 rounded-2xl p-7 md:p-8 h-full flex flex-col shadow-[0_2px_20px_-8px_rgba(0,0,0,0.08)] hover:shadow-[0_20px_40px_-15px_rgba(28,57,40,0.18)] hover:-translate-y-1 hover:border-brand-gold/30 transition-all duration-300" data-id="element-1015">
                <Quote className="w-8 h-8 text-brand-gold/30 mb-3" strokeWidth={2.5} data-id="element-1016" />
                <div className="flex gap-0.5 mb-4" data-id="element-1017">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-1018" />)}
                </div>
                <p className="text-brand-text/85 leading-relaxed mb-6 flex-grow text-base md:text-lg font-medium" data-id="element-1019">
                  "{testimonial.quote}"
                </p>
                <div className="h-px bg-brand-text/8 mb-5" data-id="element-1020"></div>
                <div className="flex items-center gap-3.5" data-id="element-1021">
                  <div className="relative flex-shrink-0" data-id="element-1022">
                    <img src={testimonial.image} alt={testimonial.name} loading="lazy" className="w-12 h-12 rounded-full object-cover ring-2 ring-white shadow-md" data-id="element-1023" />
                    <span className="absolute -bottom-0.5 -right-0.5 w-4 h-4 bg-brand-green rounded-full border-2 border-white flex items-center justify-center" data-id="element-1024">
                      <span className="text-white text-[8px] font-bold leading-none" data-id="element-1025">
                        ✓
                      </span>
                    </span>
                  </div>
                  <div className="min-w-0" data-id="element-1026">
                    <p className="font-semibold text-brand-green leading-tight truncate" data-id="element-1027">
                      {testimonial.name}
                    </p>
                    <p className="text-xs text-brand-text/55 mt-0.5 truncate" data-id="element-1028">
                      {testimonial.role}
                    </p>
                  </div>
                </div>
              </article>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}